import { type Database } from '@databases/model/database';

import {
  serializeDatabaseContents,
  serializeSelectedCells,
  type SelectedCells,
  type JiraIssueDetailsResolver,
  type ConfluencePageConnectionResolver,
} from './contents';
import { serializeDatabaseSchema } from './schema';
import { serializeDatabaseViews } from './view';
import { Warnings } from './warnings';

export type {
  SelectedCells,
  JiraIssueDetailsResolver,
  ConfluencePageConnectionResolver,
} from './contents';
export { createSelectedCells, getCellKey } from './contents';

export type SerializeDatabaseOptions = {
  currentViewId?: string;
  entryIds?: readonly string[];
  fieldIds?: readonly string[];
  resolveJiraIssueDetails?: JiraIssueDetailsResolver;
  resolveConfluencePageConnection?: ConfluencePageConnectionResolver;
};

export function serializeDatabase(
  database: Database,
  selectedCells: SelectedCells,
  options: SerializeDatabaseOptions = {}
) {
  const {
    currentViewId,
    entryIds,
    fieldIds,
    resolveJiraIssueDetails,
    resolveConfluencePageConnection,
  } = options;

  const warnings = new Warnings();
  let output = '';
  const rowIdToEntryIdMappings = new Map<string, string>();

  output += serializeDatabaseSchema(database, warnings);
  output += '\r\n\r\n';

  output += serializeDatabaseViews(database, warnings, currentViewId);
  output += '\r\n\r\n';

  output += serializeDatabaseContents(
    database,
    warnings,
    rowIdToEntryIdMappings,
    entryIds,
    fieldIds,
    resolveJiraIssueDetails,
    resolveConfluencePageConnection
  );

  if (selectedCells.size > 0) {
    output += '\r\n\r\n';
    output += serializeSelectedCells(selectedCells, database, rowIdToEntryIdMappings);
  }

  return {
    output,
    warnings,
    rowIdToEntryIdMappings,
  };
}
